import axios, { CancelTokenSource, CancelToken as axiosCancelToken } from 'axios';

export type cancelTokenSource = CancelTokenSource | AbortController;

export type CancelToken = axiosCancelToken;
// 添加请求控制
export const addRequestControllerFn = <T extends 'axios' | 'fetch', P = T extends 'axios' ? CancelTokenSource : AbortController>(
    type: 'axios' | 'fetch',
    requestControllers: any
): P => {
    if (type === 'axios') {
        const source = axios.CancelToken.source();
        requestControllers.current.push(source);
        return source as P;
    }
    const abort = new AbortController();
    requestControllers.current.push(abort);
    return abort as P;
};
// 终止所有执行
export const interruptAllExcuteFn = (
    reason: 'timeout_cancel' | 'send_cancel',
    { requestControllers, excuteTimer, isContinueExcuteRecords }: any
) => {
    if (requestControllers.current.length) {
        requestControllers.current.forEach((controller: any) => {
            (controller as CancelTokenSource)?.cancel?.(reason);
            (controller as AbortController)?.abort?.(reason);
        });
        requestControllers.current = [];
    }
    if (reason === 'send_cancel') {
        clearTimeout(excuteTimer.current);
        isContinueExcuteRecords.current = {};
    }
};
